<template>
  <a class="c_cs_link" :href="getHrefs()" :target="newWindow() ? '_blank' : null">
    <IconSVG :handle="getIcon()" color="black" aria-hidden />
    <span>{{ linkLabel }}</span>
  </a>
</template>

<script>
export default {
  props: {
    customUrl: String,
    entry: Array,
    asset: Array,
    openInANewWindow: Boolean,
    linkLabel: String,
  },
  components: {
    IconSVG: () => import('Components/icon_svg/IconSVG.vue'),
  },
  methods: {
    getHrefs() {
      // Return URL of entry or asset
      if (!this.customUrl?.length) {
        return this.entry?.length ? this.localePath(`/${this.entry[0]?.uri}`) : this.asset[0]?.url;
      }
      // Otherwise return custom URL, or null if no value exists
      return this.customUrl || null;
    },
    newWindow() {
      return this.customUrl || this.openInANewWindow || this.asset[0]?.kind === 'pdf';
    },
    getIcon() {
      return this.asset[0]?.kind === 'pdf' ? 'pdf' : 'new_window_2023';
    },
  },
};
</script>

<style lang="scss">
.c_cs_link {
  $self: &;
  display: flex;
  align-items: center;
  margin-right: px_to_rem(40);
  margin-top: px_to_rem(20);
  color: $color_black;
  text-decoration: none;
  @include font('graphik_medium');
  &:hover {
    text-decoration: underline;
  }
  .c_icon_svg {
    flex-shrink: 0;
    width: px_to_rem(45);
    margin-right: px_to_rem(18);
  }
}
</style>
